// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapLeftOutlinedSvg from "@fishx/icons-svg/es/asn/SwapLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapLeftOutlinedSvg
  }));
};

SwapLeftOutlined.displayName = 'SwapLeftOutlined';
export default React.forwardRef(SwapLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwapLeftOutlined.js
// module id = 4205
// module chunks = 0